import isFunction from 'lodash-es/isFunction';
import { TFocusRetriever } from './focusController';
import { debugDispatcher } from '../debug';

const historySize = 50;

/**
 * The GlobalFocus helper keeps a list of the last focused elements and allows
 * to retrieve the last focused element which matches against a query selector.
 */
export const globalFocus = new (class {
  focused: (HTMLElement | TFocusRetriever)[] = [];

  #onFocusCallbacks: (() => unknown)[] = [];

  offFocus(cb: () => unknown) {
    this.#onFocusCallbacks = this.#onFocusCallbacks.filter(
      (current) => current !== cb,
    );
  }

  onFocus(cb: () => unknown) {
    this.#onFocusCallbacks.push(cb);

    return () => {
      this.offFocus(cb);
    };
  }

  constructor() {
    debugDispatcher.on(
      'focusHistory',
      () => {
        console.info(this.focused);
      },
      'Muestra el historial de elementos que recibieron foco.',
    );
  }

  inDocument(el: HTMLElement | TFocusRetriever) {
    return (
      el instanceof Function ||
      (el instanceof HTMLElement && el.offsetParent !== null)
    );
  }

  set focus(element: HTMLElement | TFocusRetriever) {
    this.focused = this.focused.filter((el) => {
      const existsInDocument = this.inDocument(el) && element !== el;

      return existsInDocument;
    });
    this.focused.unshift(element);
    if (this.focused.length > historySize) {
      this.focused = this.focused.splice(0, historySize);
    }

    this.#onFocusCallbacks.forEach((cb) => cb());
  }

  get list() {
    return [...this.focused];
  }

  /**
   * @param querySelector A query selector against which the element should match
   * @returns The last HTMLElement if no querySelector argument provided or else, the last which matches
   * against that query selector.
   * */
  last(querySelector?: string, omit = 0) {
    if (querySelector)
      for (let i = omit; i <= this.focused.length; i++) {
        const storedElement = this.focused[i];
        const element =
          // eslint-disable-next-line no-nested-ternary
          (storedElement as HTMLElement)?.id !== undefined
            ? (storedElement as HTMLElement)
            : isFunction(storedElement)
              ? storedElement(false)
              : null;

        if (
          element &&
          this.inDocument(element) &&
          element.matches &&
          element.matches(querySelector)
        )
          return element;
      }
    else return this.focused[this.focused.length - 1];
    return null;
  }
})();
